import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/health/followUp/getList',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getList1 = (current, size, params) => {
  return request({
    url: '/health/followUp/getList1',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getList2 = (current, size, params) => {
  return request({
    url: '/health/followUp/getList2',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/health/followUp/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/health/followUp/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/health/followUp/submit',
    method: 'post',
    data: row
  })
}
